<div class="container">
  <div class="logo">
    <img
      width="205px"
      [src]="'assets/Hayrick/logo/'+subdomain+'/logo-dark.svg'"
      alt="Hayrick logo"
      [style.opacity]="logoLoaded ? '1' : '0'"
      [style.transition]="'opacity 0.3s ease-in-out'"
      (load)="logoLoaded = true"
      (error)="logoLoaded = true" />
    <div *ngIf="!logoLoaded" class="logo-skeleton"></div>
  </div>

  <div class="content-container">
    <div class="welcome-title-container">
      <p class="welcome-title">Welcome!</p>
    </div>

    <div class="intro-cards">
      <div class="card-container" [class.loaded]="backgroundImageLoaded">
        <div class="card">

          <p class="textSignup">Manage your employees</p>

          <p class="text2-1">Add new employees, update details, and manage your team in one place. Stay organized and save valuable time with streamlined employee management.</p>
        </div>
        <div class="card-gap"></div>
        <div class="card">

          <p class="textSignup">Configure your products</p>
          <p class="text2-1">
            Set up products and user groups that align with your company structure. Provide solutions tailored to both organizational goals and employee needs.
          </p>
        </div>
        <div class="card-gap"></div>
        <div class="card">

          <p class="textSignup">Walk the journey together</p>
          <p class="text2-1">You’re at the heart of our platform. It’s built to be easy to use, and if you ever need assistance, we’re always here to help.</p>
        </div>
      </div>
    </div>
  </div>

  <div class="login-btn">
    <button (click)="clickToNav()" class="button">Sign In!</button>
  </div>
</div>
